"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SwatchPicker = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

// class SwatchCell extends GridCell<IChoiceGroupOption, IGridCellProps<IChoiceGroupOption>> {}
var SwatchPicker = function SwatchPicker(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("pre", {
    children: ["Not Implemented", (0, _stringify.default)(props)]
  });
}; // export class SwatchPickerz extends BaseComponent<ISwatchPickerProps> {
//   private _id: string;
//   constructor(props: ISwatchPickerProps) {
//     super(props);
//     this._id = props.id || getId('swatchPicker');
//   }
//   public render(): React.ReactNode {
//     return <Grid {...this.props} onRenderItem={this._renderSwatchCell} />;
//   }
//   @autobind
//   private _renderSwatchCell(item: IChoiceGroupOption): JSX.Element {
//     const id = this._id;
//     const { onChange, onRenderItem } = this.props;
//     return (
//       <SwatchCell
//         item={item}
//         id={id}
//         role={'gridcell'}
//         getClassNames={this._getClassNames}
//         onRenderItem={onRenderItem}
//         onClick={onChange}
//         label={item.text}
//       />
//     );
//   }
//   @autobind
//   private _getClassNames(
//     theme: ITheme,
//     className: string,
//     variantClassName: string,
//     iconClassName: string | undefined,
//     menuIconClassName: string | undefined,
//     disabled: boolean,
//     checked: boolean,
//     expanded: boolean,
//     isSplit: boolean | undefined
//   ): IButtonClassNames {
//     const styles = getActionButtonStyles(theme);
//     return {
//       root: mergeStyles([
//         'ms-Button',
//         styles.root,
//         variantClassName,
//         className,
//         {
//           height: 'initial',
//           padding: '4px', // spaces 8px between items and 4px between the container and the item
//         },
//         checked && ['is-checked', styles.rootChecked],
//       ]),
//       flexContainer: mergeStyles(['ms-Button-flexContainer', styles.flexContainer]),
//     };
//   }
// }


exports.SwatchPicker = SwatchPicker;